import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, firstValueFrom, shareReplay, switchMap } from 'rxjs';

import { AdminUsersApi, AuthenticationApi, UsersApi } from '@api/backend-connector/services';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  private readonly adminUsersApi = inject(AdminUsersApi);
  private readonly usersApi = inject(UsersApi);

  readonly refresh$ = new BehaviorSubject<void>(undefined);

  async logout() {
    this;
    return window.location.replace(`${environment.apiBasePath}${AuthenticationApi.LogoutPath}`);
  }

  async init() {
    try {
      await firstValueFrom(this.usersApi.getMe());
    } catch (e) {
      if (e instanceof HttpErrorResponse && e.status == 401) {
        return window.location.replace(`${environment.apiBasePath}${AuthenticationApi.LoginFlowPath}`);
      }

      throw e;
    }
  }

  getMe() {
    return this.getMe$;
  }

  private readonly getMe$ = this.usersApi.getMe().pipe(
    switchMap((me) => this.adminUsersApi.getUser({ id: me.id })),
    shareReplay({ refCount: false, bufferSize: 1 }),
  );
}
